module.exports = require("ramda/src/prop");